module.exports = __webpack_public_path__ + "assets/img/recordIcon9.8aa42d96.png";